import {Ji} from '../../enums/Ji'

// 해당 지지가 왕지에 해당하는지 체크(자,오,묘,유)
export function checkWangJi(ji: Ji): boolean {
  return ji == Ji.JA || ji == Ji.OH || ji == Ji.MYO || ji == Ji.YU
}
